/* global google */

const marker = (fillColor) => {
  /**
   * Create a Marker with the given fill color
   */
  return {
    path: 'M11 0C7.3 0 4.2 3.3 4.2 6.8 4.2 8.3 5.1 10.4 5.8 11.9L5.8 12 11 22 16.2 12 16.2 11.9C16.9 10.4 17.8 8.4 17.8 6.8 17.8 3.3 14.7 0 11 0L11 0ZM11 3.2C13 3.2 14.6 4.8 14.6 6.8 14.6 8.8 13 10.4 11 10.4 9 10.4 7.4 8.8 7.4 6.8 7.4 4.8 9 3.2 11 3.2L11 3.2Z',
    fillOpacity: 1,
    anchor: new google.maps.Point(11, 22),
    scale: 2,
    strokeWeight: 2,
    strokeColor: '#FFF',
    strokeOpacity: 0.33,
    fillColor,
  }
}

export default (map, regions, DEBUG = false) => {
  /**
   * Create markers for all the locations in
   * each regions. Returns the list of markers.
   */
  return Object.keys(regions).reduce((accumulator, key) => {
    const region = regions[key]

    accumulator[key] = region.locations.map((position) => {
      if (DEBUG) {
        // Draw a normal marker to see if the custom marker lines up correctly.
        new google.maps.Marker({ position, map, clickable: false })
      }
      return new google.maps.Marker({
        position,
        map,
        icon: marker(region.markerColor),
        clickable: false,
      })
    })

    return accumulator
  }, {})
}
